import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Link from '../../Link';
import ListPopularLocationPhoto from '../../ListPopularLocationCoverPhoto';
import { formatLocaleData } from '../../../helpers/formatLocale';

import cs from '../../commonStyle.css';
import s from './PopularLocationItem.css';

function PopularLocationHomeSlider({
  id,
  location,
  locationAddress,
  image,
  coverPhoto,
  dynamicPopularLocation,
  intl: { locale }
}) {

  let locationName = location;
  if (dynamicPopularLocation && dynamicPopularLocation.length > 0) {
    const dynamicValue = dynamicPopularLocation.find(item => item.language === formatLocaleData(locale));
    if (dynamicValue) {
      locationName = dynamicValue.location || locationName;
    }
  }

  return (
    <Link to={`/s?&address=${locationAddress}&chosen=1`} className={s.noLine}>
      <div className={s.outLineBorder}>
        <div className={s.zoomContainer}>
          <ListPopularLocationPhoto
            className={cx(s.imageContent)}
            coverPhoto={coverPhoto}
            listPhotos={image}
            bgImage
          />
        </div>
        <div className={cx(s.infoContainer, cs.commonSubTitleText, cs.fontWeightBold, cs.paddingTop5)}>
          {locationName}
        </div>
      </div>
    </Link>
  );
}

PopularLocationHomeSlider.propTypes = {
  id: PropTypes.number,
  location: PropTypes.string.isRequired,
  locationAddress: PropTypes.string.isRequired,
  image: PropTypes.string,
  coverPhoto: PropTypes.string,
  dynamicPopularLocation: PropTypes.array
};

export default React.memo(injectIntl(withStyles(s, cs)(PopularLocationHomeSlider)));
